import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const wellbeing = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
